package com.sweetlime.bingeamigo.presentation.features.search

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.bingeamigo.model.SearchResultItem
import com.sweetlime.bingeamigo.model.UserProfile
import com.sweetlime.bingeamigo.presentation.components.PosterTile
import com.sweetlime.bingeamigo.presentation.components.SegmentedPills
import com.sweetlime.bingeamigo.presentation.ui.BrandColors

private val Line = Color(0xFF2A2A2E)

@Composable
fun SearchScreen(
    query: String,
    onQueryChange: (String) -> Unit,
    movieResults: List<SearchResultItem>,
    tvResults: List<SearchResultItem>,
    users: List<UserProfile>,
    isUserLoading: Boolean,
    followedUserIds: Set<String>,
    onFollow: (UserProfile) -> Unit,
    onUnfollow: (UserProfile) -> Unit,
    onOpenUserProfile: (String) -> Unit,
    onMovieClick: (SearchResultItem) -> Unit,
    onTvClick: (SearchResultItem) -> Unit,
    modifier: Modifier = Modifier,
) {
    var filter by rememberSaveable { mutableStateOf("TV Shows") }

    Column(modifier = modifier.fillMaxSize().background(BrandColors.Background)) {
        Column(Modifier.padding(start = 16.dp, end = 16.dp, top = 10.dp)) {
            BasicTextField(
                value = query,
                onValueChange = onQueryChange,
                singleLine = true,
                textStyle = TextStyle(color = Color.White, fontSize = 15.sp),
                cursorBrush = SolidColor(BrandColors.Primary),
                modifier = Modifier
                    .fillMaxWidth()
                    .height(46.dp)
                    .background(BrandColors.Card, RoundedCornerShape(14.dp))
                    .border(1.dp, Line, RoundedCornerShape(14.dp)),
                decorationBox = { inner ->
                    Row(
                        Modifier.fillMaxSize().padding(horizontal = 14.dp),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Icon(Icons.Filled.Search, null, tint = BrandColors.TextSecondary, modifier = Modifier.size(19.dp))
                        Spacer(Modifier.width(10.dp))
                        Box(Modifier.weight(1f)) {
                            if (query.isEmpty()) {
                                Text("Search tv shows, movies, people…", color = BrandColors.TextSecondary, fontSize = 15.sp)
                            }
                            inner()
                        }
                    }
                },
            )
            Spacer(Modifier.height(14.dp))
            SegmentedPills(
                options = listOf("TV Shows", "Movies", "Users"),
                selected = filter,
                onSelect = { filter = it },
            )
        }

        if (filter == "Users") {
            UserSearchContent(
                query = query,
                onQueryChange = {},
                users = users,
                isLoading = isUserLoading,
                followedUserIds = followedUserIds,
                onFollow = onFollow,
                onUnfollow = onUnfollow,
                onOpenProfile = onOpenUserProfile,
            )
        } else {
            val results = if (filter == "Movies") movieResults else tvResults
            val onClick: (SearchResultItem) -> Unit = if (filter == "Movies") onMovieClick else onTvClick

            Text(
                if (query.isBlank()) "Popular" else "Results",
                color = Color.White,
                fontWeight = FontWeight.ExtraBold,
                fontSize = 18.sp,
                modifier = Modifier.padding(start = 16.dp, end = 16.dp, top = 18.dp, bottom = 12.dp),
            )
            LazyVerticalGrid(
                columns = GridCells.Fixed(2),
                contentPadding = PaddingValues(start = 16.dp, end = 16.dp, bottom = 100.dp),
                horizontalArrangement = Arrangement.spacedBy(12.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp),
            ) {
                items(results, key = { it.id }) { item ->
                    PosterTile(
                        posterUrl = "https://image.tmdb.org/t/p/w342${item.posterPath.orEmpty()}",
                        title = item.title,
                        rating = item.voteAverage.takeIf { it > 0 },
                        onClick = { onClick(item) },
                    )
                }
            }
        }
    }
}
